export const ErrorPage = () => {
  return (
    <div>
      <p>Sorry, page not found.</p>
      <p>The page you're looking for doesn't exist.</p>
      <button onClick={() => (window.location.href = '/')}>
        Go to Home Page
      </button>
    </div>
  )
}
